import { FC, ComponentPropsWithoutRef } from 'react';
import classNames from 'classnames';
import styles from 'jbc-front/components/SearchForm.scss';

export const Details: FC<ComponentPropsWithoutRef<'div'>> = ({ className, children, ...rest }) => (
  <div className={classNames(styles.details, className)} {...rest}>
    {children}
  </div>
);

export const Row: FC<ComponentPropsWithoutRef<'div'>> = ({ className, children, ...rest }) => (
  <div className={classNames(styles.detailsRow, className)} {...rest}>
    {children}
  </div>
);

export const Header: FC<ComponentPropsWithoutRef<'div'>> = ({ className, children, ...rest }) => (
  <div className={classNames(styles.detailsHeader, className)} {...rest}>
    {children}
  </div>
);

export const Body: FC<ComponentPropsWithoutRef<'div'>> = ({ className, children, ...rest }) => (
  <div className={classNames(styles.detailsBody, className)} {...rest}>
    {children}
  </div>
);

export const BodyItems: FC<ComponentPropsWithoutRef<'div'>> = ({ className, children, ...rest }) => (
  <div className={classNames(styles.detailsBodyItems, className)} {...rest}>
    {children}
  </div>
);

export const BodyErrors: FC<ComponentPropsWithoutRef<'div'>> = ({ className, children, ...rest }) => (
  <div className={classNames(styles.detailsBodyErrors, className)} {...rest}>
    {children}
  </div>
);
